import { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { SingleShell } from './pages/SingleShell'
import { ProjectsList } from './pages/ProjectsList'
import { ProjectDetail } from './pages/ProjectDetail'
import { CellsList } from './pages/CellsList'
import { CellDetail } from './pages/CellDetail'
import { useStore } from './store'

/**
 * Router host.
 *
 *   /                     — single-part workspace (dockview, viewport, etc.)
 *   /projects             — batch workspaces list
 *   /projects/<id>        — one project (inputs, generate, outputs)
 */
export function App() {
  const store = useStore()
  const theme = store.preferences.theme
  const fontSize = store.preferences.fontSize

  useEffect(() => {
    store.pingApi()
    store.loadToolLibrary()
    const h = setInterval(() => store.pingApi(), 10_000)
    return () => clearInterval(h)
  }, [store])

  useEffect(() => {
    document.documentElement.dataset.theme = theme
    document.documentElement.style.setProperty('--amatl-font-size', `${fontSize}px`)
    document.body.classList.toggle('bp5-dark', theme === 'dark')
  }, [theme, fontSize])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SingleShell />} />
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/cells" element={<CellsList />} />
        <Route path="/cells/:id" element={<CellDetail />} />
      </Routes>
    </BrowserRouter>
  )
}
